<script setup lang="ts">
import type { NavIconName } from './nav-icons.ts'

/**
 * A navigation destination's glyph. Drawn on KindIcon's 16 grid with the same constant
 * 1.7-unit stroke, butt caps and mitre joins, so the sidebar reads as the same hand as the
 * entry-kind icons and the mark rather than a stock icon set beside them. Decorative only:
 * the link it sits in already carries the destination's name, even when the label is
 * visually collapsed into the icon rail.
 */
defineProps<{ name: NavIconName }>()
</script>

<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    aria-hidden="true"
    class="block shrink-0"
    fill="none"
    stroke="currentColor"
    stroke-width="1.7"
    stroke-linecap="butt"
    stroke-linejoin="miter"
  >
    <g v-if="name === 'dashboard'">
      <path d="M2.5 2.5h4.6v5.2H2.5zM9 2.5h4.5v3H9zM2.5 9.6h4.6v3.9H2.5zM9 7.6h4.5v5.9H9z" />
    </g>
    <g v-else-if="name === 'transactions'">
      <path d="M2 3.5h2M2 8h2M2 12.5h2" />
      <path d="M6 3.5h8M6 8h8M6 12.5h5.5" />
    </g>
    <g v-else-if="name === 'accounts'">
      <path d="M2.5 6.2 8 3l5.5 3.2" />
      <path d="M2.5 13.2h11" />
      <path d="M4.4 7.6v4M8 7.6v4M11.6 7.6v4" />
    </g>
    <g v-else-if="name === 'contacts'">
      <circle cx="8" cy="5.6" r="2.6" />
      <path d="M2.8 13.6c.6-2.6 2.6-4 5.2-4s4.6 1.4 5.2 4" />
    </g>
    <g v-else-if="name === 'loans'">
      <path d="M12.6 3.4 3.4 12.6" />
      <circle cx="4.6" cy="4.6" r="1.8" />
      <circle cx="11.4" cy="11.4" r="1.8" />
    </g>
    <g v-else-if="name === 'garage'">
      <path d="M2.2 11.4V8.6l1.6-3.8h8.4l1.6 3.8v2.8z" />
      <path d="M2.2 8.6h11.6" />
      <circle cx="5" cy="11.8" r="1.1" />
      <circle cx="11" cy="11.8" r="1.1" />
    </g>
    <g v-else-if="name === 'reports'">
      <path d="M2.4 13.4h11.2" />
      <path d="M4.4 11.4V7.6M8 11.4V3.6M11.6 11.4V9" />
    </g>
    <g v-else-if="name === 'planning'">
      <circle cx="8" cy="8" r="5.4" />
      <circle cx="8" cy="8" r="2.2" />
      <path d="M8 1.4v2.2M14.6 8h-2.2" />
    </g>
    <g v-else-if="name === 'relationships'">
      <circle cx="5.8" cy="8" r="3.4" />
      <circle cx="10.2" cy="8" r="3.4" />
    </g>
    <g v-else>
      <path d="M2.4 9.2 4 3.4h8l1.6 5.8v3.8H2.4z" />
      <path d="M2.4 9.2h3.4l.8 1.6h2.8l.8-1.6h3.4" />
    </g>
  </svg>
</template>
